import { useMemo } from 'react';
import { useExternalCalendarConnectionsQuery } from 'shared/hooks/queries/use-external-calendar-connections-query';
import { useUser } from 'shared/hooks/use-user';

export const useExternalCalendarConnections = () => {
  const user = useUser();
  const { data } = useExternalCalendarConnectionsQuery(user?.uid);

  return useMemo(() => data ?? [], [data]);
};
